export enum CategoryGroup {
  CUPS = 'CUPS',
  BOWLS = 'BOWLS',
  PIZZA = 'PIZZA',
}
